import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SubSink } from "subsink";
import { Router } from '@angular/router';

import { MessageFor, AppStorage } from "../../providers/enum";
import { CommonUtilsService } from "../../shared/services/common-utils.service";
import { FetchJsonService } from "../../shared/services/fetch-json.service";
import { StorageService } from "../../shared/services/storage.service";
import { MyProfileService } from "./services/my-profile.service";

@Component({
  selector: "app-my-profile",
  templateUrl: "./my-profile.component.html",
  styleUrls: ["./my-profile.component.scss"],
})
export class MyProfileComponent implements OnInit {
  //#region variables

  public myProfileMessage: any;
  public isCheckValidation = false;
  public errorMessage: string = "";
  public showLoading = false;
  public userData: any;
  public streamDetails: any;
  public myProfileFormGroup: FormGroup;
  public streamTitle: string;
  public storageData: any;
  private subs = new SubSink();

  //#endregion

  //#region life-cycle hook

  constructor(private router: Router,
    private fetchJsonService: FetchJsonService,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private myProfileService: MyProfileService
  ) {}

  ngOnInit(): void {
    // let data = this.storageService.get(AppStorage.data, true);

    // let eventData = this.storageService.get(AppStorage.streamDetails, true);
    // this.streamDetails = JSON.parse(eventData);
    // this.streamTitle = this.streamDetails[0].stream_title;

    // this.userData = JSON.parse(data);
    this.getMyProfileFormMessage();
    this.createMyProfileFormGroup();
    let data = JSON.parse(this.storageService.get(AppStorage.data, true));
    this.storageData = data;
    this.getUserData(data.userCode, data.appId);
    // if (this.userData && this.userData.name && this.userData.email) {
    //   this.fillSupportForm();
    // }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  //#endregion

  //#region private methods

  private getMyProfileFormMessage(): void {
    this.subs.sink = this.fetchJsonService
      .getMessagesList()
      .subscribe((messageList) => {
        this.myProfileMessage = messageList[MessageFor.MyProfileForm];
      });
  }

  private createMyProfileFormGroup(): void {
    this.myProfileFormGroup = this.formBuilder.group(
      {
        fname: [null, Validators.required],
        lname: [null, Validators.required],
        email: [null, [Validators.required, CommonUtilsService.checkEmail]],
        phone: [null, Validators.required],
      },
      {
        validator: [CommonUtilsService.checkEmail("email", true)],
      }
    );
  }

  private async getUserData(userCode, appCode) {
    try {
      let result = await this.myProfileService
        .getUserDataByUserCode(userCode, appCode)
        .toPromise();
      // console.log("stream detail:", result);
      if (result.request_status) {
        this.userData = result.response_data[0]
        this.fillMyProfileForm();
      }
    } catch (error) {
      //console.log('error: ', error);
      this.showLoading = false;
    }
  }

  private fillMyProfileForm(): void {
    this.myProfileFormGroup.patchValue({
      fname: this.userData.fname,
      lname: this.userData.lname,
      email: this.userData.email,
      phone: this.userData.phone
    });
  }

  //#endregion

  //#region public methods

  public get myProfileControls() {
    return this.myProfileFormGroup.controls;
  }

  public onSubmitClick(): void {
    if (this.myProfileFormGroup.invalid) {
      return;
    }

    this.showLoading = true;
    this.isCheckValidation = true;

    /*
    let obj = {
      appName: this.streamTitle,
      from_name: this.myProfileControls.name.value,
      from_email: this.myProfileControls.email.value,
      email_message: this.myProfileControls.message.value

    } */
    var formDataG = new FormData();
    formDataG.append("username", this.userData.username);
    formDataG.append("password", this.userData.password);
    formDataG.append("fname", this.myProfileControls.fname.value);
    formDataG.append("lname", this.myProfileControls.lname.value);
    formDataG.append("email", this.myProfileControls.email.value);
    formDataG.append("phone", this.myProfileControls.phone.value);
    formDataG.append("appCodes", this.storageData.appId);
    formDataG.append("userCode", this.storageData.userCode);

    //console.log("sup obj = ", formDataG);
    this.subs.sink = this.myProfileService.updateMyProfile(formDataG).subscribe(
      (response: any) => {
        //console.log('response email: ', response);
        if (response.status === 0) {
          this.errorMessage =
            "Oops something went wrong please try again later.";
        } else {
          this.errorMessage = response.msg;
        }
        this.showLoading = false;
      },
      (error) => {
        //console.log('error: ', error);
        this.errorMessage = "oops something went wrong please try again later.";
        this.showLoading = false;
      }
    );
  }

  public onCancel(): void {
    this.router.navigateByUrl(``);
  }

  //#endregion
}
